/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsRhombusFill: {
  name: 'rhombus-fill';
  data: string;
} = {
  name: 'rhombus-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.414 3a2 2 0 0 0-2.828 0L3 10.586a2 2 0 0 0 0 2.828L10.586 21a2 2 0 0 0 2.828 0L21 13.414a2 2 0 0 0 0-2.828L13.414 3Z" fill="currentColor"/></svg>`,
};
